/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NoteTextArea/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import EditableTextArea from 'DesignSystem/EditableTextArea/react'
import React from 'react'
import Template from './Template/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function NoteTextArea({
  children,
  viewPath = "/DesignSystem/NoteTextArea",
  value,
  onChange,
  disabled,
  toolbar,
  menubar = true,
  inline,
  autocomplete = true,
  toolbarPersist = true,
  placeholder,
  maxLength,
  plaintext = true,
  templateTags
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onAutocompleteAction = fromHelpers.useOnAutocompleteAction({
  children,
  viewPath,
  value,
  onChange,
  disabled,
  toolbar,
  menubar,
  inline,
  autocomplete,
  toolbarPersist,
  placeholder,
  maxLength,
  plaintext,
  templateTags
  
})
let onAutocompleteFetch = fromHelpers.useOnAutocompleteFetch({
  children,
  viewPath,
  value,
  onChange,
  disabled,
  toolbar,
  menubar,
  inline,
  autocomplete,
  toolbarPersist,
  placeholder,
  maxLength,
  plaintext,
  templateTags
  
})
  return (<React.Fragment
>
<Template
  viewPath={`${viewPath}/Template`}
/>
<div
  data-testid="NoteTextArea.Vertical"
  data-view-path={viewPath}
 style={{'--bblr-1-ZDis2d': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-2-ZDis2d': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-3-ZDis2d': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-4-ZDis2d': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-5-ZDis2d': dtColorsNeutral200,'--pl-6-ZDis2d': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-7-ZDis2d': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-8-ZDis2d': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-9-ZDis2d': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mt-10-ZDis2d': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mb-11-ZDis2d': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block note-textarea ${styles.Vertical}`}
>
<EditableTextArea
  viewPath={`${viewPath}/EditableTextArea`}
 value={value}
 onChange={onChange}
 disabled={disabled}
 toolbar={toolbar}
 menubar={menubar}
 inline={inline}
 selector="note-textarea"
 autocomplete={autocomplete}
 onAutocompleteAction={onAutocompleteAction}
 onAutocompleteFetch={onAutocompleteFetch}
 toolbarPersist={toolbarPersist}
 placeholder={placeholder}
 maxLength={maxLength}
 plaintext={plaintext}
 autoFocus={true}
 templateTags={templateTags}
/>
</div>
{children}
</React.Fragment>)
}